// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getLineasFinancierasReducer } from './getLineasFinancieras';
import { reducer as goPreviousStepReducer } from './goPreviousStep';
import { reducer as updateDatosFinancierosStateReducer } from './updateDatosFinancierosState';
import { reducer as setDefaultAltaLineaReducer } from './setDefaultAltaLinea';
import { reducer as getEntidadesOtorgantesReducer } from './getEntidadesOtorgantes';
import { reducer as getTiposCreditoReducer } from './getTiposCredito';
import { reducer as addCuotaReducer } from './addCuota';
import { reducer as updateAsignacionDeLineasReducer } from './updateAsignacionDeLineas';
import { reducer as deleteCuotaReducer } from './deleteCuota';
import { reducer as getBrandsReducer } from './getBrands';
import { reducer as getModelsReducer } from './getModels';
import { reducer as getVersionsReducer } from './getVersions';
import { reducer as addAutoReducer } from './addAuto';
import { reducer as editCuotaReducer } from './editCuota';
import { reducer as confirmEditCuotaReducer } from './confirmEditCuota';
import { reducer as cancelEditCuotaReducer } from './cancelEditCuota';
import { reducer as deleteAutoReducer } from './deleteAuto';
import { reducer as confirmEditCuotaAsyncReducer } from './confirmEditCuotaAsync';
import { reducer as newLineaFinancieraReducer } from './newLineaFinanciera';
import { reducer as getTiposTasaReducer } from './getTiposTasa';
import { reducer as setStatePropertyReducer } from './setStateProperty';
import { reducer as getLineaFinancieraByIdReducer } from './getLineaFinancieraById';
import { reducer as getCreditsCompareReducer } from './getCreditsCompare';
import { reducer as updateCreditsCompareFiltradasReducer } from './updateCreditsCompareFiltradas';
import { reducer as updateLineaFinancieraReducer } from './updateLineaFinanciera';
import { reducer as getLineasSimulacionFinanciacionReducer } from './getLineasSimulacionFinanciacion';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as clearModelsReducer } from './clearModels';
import { reducer as clearVersionsReducer } from './clearVersions';

const reducers = [
  getLineasFinancierasReducer,
  goPreviousStepReducer,
  updateDatosFinancierosStateReducer,
  setDefaultAltaLineaReducer,
  getEntidadesOtorgantesReducer,
  getTiposCreditoReducer,
  addCuotaReducer,
  updateAsignacionDeLineasReducer,
  deleteCuotaReducer,
  getBrandsReducer,
  getModelsReducer,
  getVersionsReducer,
  addAutoReducer,
  editCuotaReducer,
  confirmEditCuotaReducer,
  cancelEditCuotaReducer,
  deleteAutoReducer,
  confirmEditCuotaAsyncReducer,
  newLineaFinancieraReducer,
  getTiposTasaReducer,
  setStatePropertyReducer,
  getLineaFinancieraByIdReducer,
  getCreditsCompareReducer,
  updateCreditsCompareFiltradasReducer,
  updateLineaFinancieraReducer,
  getLineasSimulacionFinanciacionReducer,
  clearModelsReducer,
  clearVersionsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
